import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Icon, IconNameEnum, IconTypeEnum } from "../../../components/Icon";
import { useModal } from "../../../hooks/useModal";
import { showNotification } from "../../../reducers/notificationReducer";
import { getCollectionPointDetail } from "../../../selectors/collectionPoint";
import { InvitiationStatus } from "../../../types/collectionPoint";
import { NotificationSeverity } from "../../../types/notification";
import { getModuleClassNames } from "../../../utils/getModuleClassNames";
import { DeleteInviteToMobileAppModal } from "../DeleteInviteToMobileAppModal/DeleteInviteToMobileAppModal";

import styles from "./InvitationSentComponent.module.scss";

export const InvitationSentComponent: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { invitationToken, invitationStatus } = useSelector(getCollectionPointDetail);
  const deleteInviteToMobileAppModal = useModal();

  const invitationUrl = `${process.env.REACT_APP_CITIZEN_APP_URL}/auth/register/${invitationToken}`;

  const handleCopyToClipboard = (): void => {
    navigator.clipboard.writeText(invitationUrl);
    dispatch(
      showNotification({
        message: t("invitationUrlCopiedToClipboard"),
        severity: NotificationSeverity.success,
        hideAfter: 3000,
      })
    );
  };

  const appliedContainerClassNameArray = [styles.container];
  let appliedTextResourceCode = "";
  switch (invitationStatus) {
    case InvitiationStatus.Invited:
      appliedContainerClassNameArray.push(styles.orange);
      appliedTextResourceCode = "invitationSent";
      break;
    case InvitiationStatus.Registered:
      appliedContainerClassNameArray.push(styles.green);
      appliedTextResourceCode = "userActivated";
      break;
  }

  return (
    <div className={getModuleClassNames(appliedContainerClassNameArray)}>
      <DeleteInviteToMobileAppModal
        isModalVisible={deleteInviteToMobileAppModal.isModalVisible}
        toggleModalVisibility={deleteInviteToMobileAppModal.toggleModalVisibility}
      />
      {invitationStatus === InvitiationStatus.Registered && (
        <Icon name={IconNameEnum.check} type={IconTypeEnum.green} size="16px" />
      )}
      <p className={styles.text}>{t(appliedTextResourceCode)}</p>
      {invitationStatus !== InvitiationStatus.Registered && (
        <div className={styles.clipContainer} onClick={handleCopyToClipboard}>
          <Icon name={IconNameEnum.paperclip} type={IconTypeEnum.white} size="20px" />
        </div>
      )}
      <div className={styles.clipContainer} onClick={deleteInviteToMobileAppModal.toggleModalVisibility}>
        <Icon name={IconNameEnum.cross} type={IconTypeEnum.white} size="12px" />
      </div>
    </div>
  );
};
